/**
 * @generated SignedSource<<e6655463bc6e1f214bd0a236890f2324>>
 * @relayHash 1e2ad799f8d3d0d37a4fee44eff1d09c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1e2ad799f8d3d0d37a4fee44eff1d09c

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CancelFileUploadRequestInput = {
  appointmentId: string;
};
export type useCancelFileUploadRequestMutation$variables = {
  input: CancelFileUploadRequestInput;
};
export type useCancelFileUploadRequestMutation$data = {
  readonly cancelFileUploadRequest: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly fileUploadRequest: {
      readonly " $fragmentSpreads": FragmentRefs<"FileUploadRequestFragment">;
    } | null;
  };
};
export type useCancelFileUploadRequestMutation = {
  response: useCancelFileUploadRequestMutation$data;
  variables: useCancelFileUploadRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCancelFileUploadRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CancelFileUploadRequestPayload",
        "kind": "LinkedField",
        "name": "cancelFileUploadRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FileUploadRequest",
            "kind": "LinkedField",
            "name": "fileUploadRequest",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FileUploadRequestFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCancelFileUploadRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CancelFileUploadRequestPayload",
        "kind": "LinkedField",
        "name": "cancelFileUploadRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FileUploadRequest",
            "kind": "LinkedField",
            "name": "fileUploadRequest",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sessionCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "1e2ad799f8d3d0d37a4fee44eff1d09c",
    "metadata": {},
    "name": "useCancelFileUploadRequestMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "98e86ff08e4e8ca4a7cfbc2ca04252b4";

export default node;
